import { render, staticRenderFns } from "./cv-tag-skeleton.vue?vue&type=template&id=06bf2e23&"
import script from "./cv-tag-skeleton.vue?vue&type=script&lang=js&"
export * from "./cv-tag-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports